// src/utils/toast.ts

import AsyncLocalStorage from "../utils/AsyncLocalStorage";
import { soundList, PushSettingType, pushSettingState } from "../recoil/sound";
import { getRecoil } from "recoil-nexus";
import { currentStoreState } from "../recoil/auth";

let timer: any;

class SoundControl {
  private oAudio: any;
  private oAudioOnce: any;
  private iLoopCount = 0;
  private defaultSettings: PushSettingType = {
    effect: soundList.effectSound[2],
    volume: 10,
    orderCount: 3,
    infinite: false,
    delay: 3,
  };

  public init = async () => {
    this.iLoopCount = 0;
    if (this.oAudio) {
      this.oAudio.currentTime = 0;
    }
    //let oPushSettings = getRecoil(pushSettingState);
    //if (oPushSettings && !this.oAudio) {
    //  this.oAudio = new Audio(oPushSettings.effect);
    //}
  };

  public playSound = () => {
    console.log("SoundControl playSound");
    const that = this;
    const oPushSettings = AsyncLocalStorage.getItem("pushSetting");
    let iLoopCountSound = 0;
    //let oPushSettings = getRecoil(pushSettingState);
    if (oPushSettings) {
      if (
        this.oAudio &&
        this.oAudio.paused === false &&
        this.oAudio.currentTime !== 0
      ) {
        return;
      }
      this.oAudio = new Audio(oPushSettings.effect);
      this.oAudio.volume = oPushSettings.volume / 10;
      iLoopCountSound = oPushSettings.orderCount;

      this.oAudio.onended = function () {
        // console.log("The audio has ended", that.iLoopCount);
        timer = setTimeout(() => {
          clearTimeout(timer);
          if (
            that.iLoopCount < iLoopCountSound ||
            // oPushSettings.infinite === true ||
            iLoopCountSound === 0
          ) {
            that.playSound();
          }
        }, oPushSettings.delay * 1000);
      };
    }

    //console.log('iLoopCountSound??????????????????', iLoopCountSound);
    if (this.oAudio) {
      console.log("this.oAudio.ended", this.oAudio.ended);
      //console.log('this.oAudio.duration', this.oAudio.duration);
      console.log("this.oAudio.currentTime", this.oAudio.currentTime);
      console.log("this.oAudio.paused", this.oAudio.paused);

      let oPlay = this.oAudio.play();
      that.iLoopCount++;
      console.log("count", this.iLoopCount, iLoopCountSound);
      if (oPlay !== undefined) {
        oPlay
          .then((_: any) => {
            //console.log('playing??????????????????');
          })
          .catch((error: any) => {
            //console.log('error', error);
          });
      }
    }
  };

  public stopSound = () => {
    const that = this;
    that.iLoopCount = 1000;
    clearTimeout(timer);
    if (this.oAudio) {
      this.oAudio.pause();
      this.oAudio.currentTime = 0;
      console.log("~~~~~~~~~stopSound~~~~~~~~~");
    }
  };

  public playSoundOnce = () => {
    // const oPushSettings = getRecoil(pushSettingState);
    const oPushSettings = AsyncLocalStorage.getItem("pushSetting");

    if (oPushSettings) {
      // if (
      //   this.oAudioOnce &&
      //   this.oAudioOnce.paused === false &&
      //   this.oAudioOnce.currentTime !== 0
      // ) {
      //   return;
      // }

      if (
        this.oAudio &&
        this.oAudio.paused === false &&
        this.oAudio.currentTime !== 0
      ) {
        console.log("~~~~~~~~~~~audio once stop~~~~~~~~~~~~~~");
        return;
      }

      this.oAudioOnce = new Audio(oPushSettings.effect);
      this.oAudioOnce.volume = oPushSettings.volume / 10;
      this.oAudioOnce.currentTime = 0;
    }

    if (this.oAudioOnce) {
      console.log("this.oAudioOnce", this.oAudioOnce, this.oAudioOnce.volume);
      let oPlay = this.oAudioOnce.play();
      if (oPlay !== undefined) {
        oPlay
          .then((_: any) => {
            //console.log('playing??????????????????');
          })
          .catch((error: any) => {
            //console.log('error', error);
          });
      }
    }
  };

  public playSilentSound = () => {
    let oPushSettings: PushSettingType =
      AsyncLocalStorage.getItem("pushSetting");
    if (!oPushSettings) {
      AsyncLocalStorage.setItem(
        "pushSetting",
        JSON.stringify(this.defaultSettings)
      );
    }
    if (oPushSettings && !oPushSettings.effect) {
      AsyncLocalStorage.setItem(
        "pushSetting",
        JSON.stringify(this.defaultSettings)
      );
    }

    oPushSettings = AsyncLocalStorage.getItem("pushSetting");
    if (oPushSettings) {
      let oSilentSound = new Audio(oPushSettings.effect);
      oSilentSound.volume = 0;
      let oPlay = oSilentSound.play();
      if (oPlay !== undefined) {
        oPlay.then((_: any) => {}).catch((error: any) => {});
      }
    }
  };
}

export default new SoundControl();
